import { SupportedLanguages, supportedLanguages } from './types'

export const mapLocaleToAvailableLanguage = (locale: string): SupportedLanguages => {
  const lang = locale.split('-')[0]
  if (supportedLanguages.includes(lang as SupportedLanguages)) {
    return lang as SupportedLanguages
  }

  return SupportedLanguages.EN
}

export const getDefaultLocalizationFromLocale = (locale: string) => {
  const language = mapLocaleToAvailableLanguage(locale)

  switch (language) {
    case SupportedLanguages.SV:
      return 'sv-se'
    case SupportedLanguages.EL:
      return 'el-gr'
    case SupportedLanguages.EN:
    default:
      return 'en-gb'
  }
}

export const getDefaultLocalizationFromBrowser = () => {
  if (typeof navigator === 'undefined') {
    return 'en-gb'
  }
  const locale = navigator.language || 'en-gb'
  return getDefaultLocalizationFromLocale(locale)
}
